export class ResponsivePage {
    //mobile menu open / close logic
    // ------------------------------------------

    constructor() {
        this._body = jQuery("body");
        this.mobileMenuBtn = jQuery(".mobile-menu-btn");
        this.mobileMenu = jQuery(".mobile-menu");
        this._clickTrap = jQuery(".page-container .click-trap");
    }

    get clickTrap() {
        return this._clickTrap;
    }

    get body() {
        return this._body;
    }

    openMobileMenu() {
        let that = this;
        return function () {
            that.body.addClass("open-menu");
            that.clickTrap.on("click touchstart", function (event) {
                event.preventDefault();
                that.closeMobileMenu();
            });
        }
    }

    closeMobileMenu() {
        this.body.removeClass("open-menu");
        this.clickTrap.off("click", this.closeMobileMenu);
    }

    bindClickToMobileMenuBtn() {
        this.mobileMenuBtn.on("click", this.openMobileMenu());
    }

    static setup() {
        var page = new ResponsivePage();
        page.bindClickToMobileMenuBtn();
    }
}
